import { LimitOrderPostEventSections } from 'components/Workspaces/SecondaryMarketPostEvent/Tabs/limitOrder/sections.connect';

export type LimitOrderFormContentProps = { tabId: string };
export function LimitOrderFormContent({ tabId }: LimitOrderFormContentProps) {
  return (
    <>
      <LimitOrderPostEventSections.ConnectedProductSummary tabId={tabId} />
      <LimitOrderPostEventSections.ConnectedTradeInformation tabId={tabId} isModification={true} />
      <LimitOrderPostEventSections.ConnectedLimit formId={tabId} workspace="secondaryMarketPostEvents" />
      <LimitOrderPostEventSections.ConnectedBookingInformation tabId={tabId} />
    </>
  );
}
